import { all } from "redux-saga/effects";
import userProjectDetailsSaga from "./userProjectDetailsSaga";
import saveFormDetails from "./saveFormData";
import unlinkProjectSaga from "./unlinkProjectSaga";
import offerTypesSaga from "./offerTypesSags";
import liveOffersSaga from "./liveOffersSaga"

// Root saga
function* rootSaga() {
  yield all([
    userProjectDetailsSaga(),
    saveFormDetails(), 
    unlinkProjectSaga(),
    offerTypesSaga(),
    liveOffersSaga()
  ]);
}

export default rootSaga;
